module.exports = require("@mui/icons-material/KeyboardArrowRight");